import React, { useState, useEffect, useRef } from 'react';
import styles from './menu.module.css';
import { Button, Col, Row } from 'react-bootstrap';
import { IoNotificationsOutline } from "react-icons/io5";
import { Link, NavLink, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import Notifications from '../Notifications/Notifications';
import axios from 'axios';
import { BASE_URL } from '../../Apis/BaseUrl';



const TopNavbar = () => {
    const [notification, setNotification] = useState(false)
    const [unreadCount, setUnreadCount] = useState(0)
    const hasMountedRef = useRef(false)
    const isFetchingRef = useRef(false)

    const navigate = useNavigate()
    const handleLogout = () => {
        navigate('/')
        Cookies.remove("v&b_token")
    }

    // Fetch unread notification count
    const fetchUnreadCount = async () => {
        if (isFetchingRef.current) return;

        try {
            let profileTokenJson = Cookies.get("v&b_token");
            if (!profileTokenJson) return;

            isFetchingRef.current = true;
            let profileToken = JSON.parse(profileTokenJson);
            let token = profileToken.token;

            let res = await axios.get(`${BASE_URL}/notification/stats`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            if (res.data && res.data.data && res.data.data.unseen !== undefined) {
                setUnreadCount(res.data.data.unseen);
            }
        } catch (error) {
            console.error('Error fetching notification count:', error);
        } finally {
            isFetchingRef.current = false;
        }
    }

    // Fetch unread count only once on mount
    useEffect(() => {
        if (!hasMountedRef.current) {
            hasMountedRef.current = true;
            fetchUnreadCount();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Empty array - only run on mount

    // Track timeout for cleanup
    const notificationTimeoutRef = useRef(null)

    // Refresh count when notifications modal closes
    const handleNotificationToggle = (show) => {
        setNotification(show);

        // Clear any existing timeout
        if (notificationTimeoutRef.current) {
            clearTimeout(notificationTimeoutRef.current);
            notificationTimeoutRef.current = null;
        }

        if (!show && !isFetchingRef.current) {
            notificationTimeoutRef.current = setTimeout(() => {
                if (!isFetchingRef.current) {
                    fetchUnreadCount();
                }
                notificationTimeoutRef.current = null;
            }, 500);
        }
    }

    // Cleanup timeout on unmount
    useEffect(() => {
        return () => {
            if (notificationTimeoutRef.current) {
                clearTimeout(notificationTimeoutRef.current);
            }
        };
    }, [])
    return (
        <React.Fragment>
            {notification && <Notifications setterFunc={handleNotificationToggle} onNotificationUpdate={fetchUnreadCount} />}

            <Row className='w-100'>
                <div className={styles.menu}>
                    <Col md={4}>
                        <div className={styles.logo}>
                            <Link to={'/'}> <img src="/image/3dcrop1.png" alt="icon" /></Link>
                        </div>
                    </Col>

                    <Col md={8} className={styles.colAlign}>
                        <div className={styles.profile_section}>
                            {/* <div className={styles.profile_section1}>
                            <input type="text" placeholder='Search' />
                            <IoSearchSharp className={styles.serach_icon} />
                            </div> */}
                            {/* <h6><HiOutlineSupport className={styles.icon} /> Help</h6>
                            <h6><FaRegUserCircle className={styles.icon} /> Profile</h6> */}
                            <div className='d-flex gap-3 align-items-center'>
                                <Link className={[styles.visualizer]} to={'/visualize'}>
                                    <span className={styles.visualizer3D}>3D</span>
                                    <span className={styles.visualizerText}>Visualizer</span>
                                </Link>
                                <h6 onClick={() => handleNotificationToggle(!notification)} className={styles.notificationSection}>
                                    <IoNotificationsOutline className={`${styles.icon} ${styles.notificationIcon}`} />
                                    <span className={styles.notificationText}>Notifications</span>
                                    {unreadCount > 0 && (
                                        <span className={styles.notificationBadge}>{unreadCount}</span>
                                    )}
                                </h6>
                                <Button className='bg-dark border-0' onClick={handleLogout}>Logout</Button>
                            </div>
                        </div>
                    </Col>
                </div>
            </Row>

        </React.Fragment>

    )
}

export default TopNavbar